export enum ReceiptStatus {
  PENDING = 'Pending',
  DONE = 'Done',
  FAILED = 'Failed',
}

export interface Receipt {
  // set for regular (advance) receipts, tied to a real Payment. Absent for full-payment
  // (advance-offset, "closing") receipts, which have no Payment - see contractId/periodEndDate.
  paymentId?: string;
  // set for full-payment receipts instead of paymentId - which contract and which service period
  // (by its end date) this receipt closes out.
  contractId?: string;
  periodEndDate?: string;
  processor?: string;
  externalId?: string;
  status: ReceiptStatus;
  requestPayload?: Record<string, CustomAny>;
  processorResponse?: Record<string, CustomAny>;
  webhookBody?: Record<string, CustomAny>;
  error?: Record<string, CustomAny>;
  receiptUrl?: string;
}

export interface ReceiptDocument extends Receipt {
  receiptId: string;
  createdAt: string;
  updatedAt: string;
}
